import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { createFuelSupplier, editFuelSupplier } from 'features/fuelManagement/fuelManagementSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const FuelSuppliersModal = ({ closeModal, value }: { closeModal: any, value?: IFuelSuppliersModal }) => {
    const [state, setState] = useState<IFuelSuppliersModal>(value || {
        name: '',
        phoneNumber: null,
        email: null,
        address: null,
        vatId: null
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(value?.id ? editFuelSupplier(state) : createFuelSupplier(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state,
            [e.target.name]: e.target.type === 'number' ? Number(e.target.value) : e.target.value
        })

    }

    return <Modal black>
        <Flex column between center>
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Supplier</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Enter name...' labelText='Name' name='name' value={state.name} onChange={handleChange} nomarg required />
                <Input placeholder='Enter email...' labelText='Email' name='email' value={state.email} onChange={handleChange} nomarg type='email' />
                <Input placeholder='Enter phone...' labelText='Phone' name='phoneNumber' value={state.phoneNumber} onChange={handleChange} nomarg type='tel' />
                <Input placeholder='Enter address...' labelText='Address' name='address' value={state.address} onChange={handleChange} nomarg />
                <Input placeholder='Enter VAT ID...' labelText='VAT ID' name='vatId' value={state.vatId} onChange={handleChange} nomarg />

            </Flex>
            <Button mt='16' disabled={!state.name} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IFuelSuppliersModal {
    id?: number
    name: string
    phoneNumber: string
    email: string
    address: string
    vatId: string
}